import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, vShow as _vShow, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "controller-wrapper" };
const _hoisted_2 = { class: "controller-title" };
const _hoisted_3 = { class: "mr-1" };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { key: 1 };
const _hoisted_6 = { class: "table-wrapper" };
const _hoisted_7 = { class: "area-list" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_icon = _resolveComponent("v-icon");
    const _component_v_btn = _resolveComponent("v-btn");
    const _component_CreateRegisterAreaCard = _resolveComponent("CreateRegisterAreaCard");
    const _component_v_divider = _resolveComponent("v-divider");
    const _component_SearchInput = _resolveComponent("SearchInput");
    const _component_RegisteredAreaListTable = _resolveComponent("RegisteredAreaListTable");
    const _component_LoadingMask = _resolveComponent("LoadingMask");
    const _directive_btn_style = _resolveDirective("btn-style");
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["registered-area-wrapper", _ctx.getterIsCreateAreaMode ? 'open-create-area-mode' : ''])
    }, [
        _createElementVNode("div", _hoisted_1, [
            _createCommentVNode(" 등록된 구역 목록 "),
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.localeInfo.listHeaderTitle), 1 /* TEXT */),
                    _createElementVNode("span", null, "(" + _toDisplayString(_ctx.getterCheckedAreaListLength) + "/" + _toDisplayString(_ctx.getterRegisteredAreaListLength) + ")", 1 /* TEXT */)
                ]),
                _createCommentVNode(" 구역 추가 버튼 "),
                (!_ctx.isSelectMode)
                    ? _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        onClick: _ctx.handleClickAddAreaToggleButton
                    }, {
                        default: _withCtx(() => [
                            (_ctx.getterIsCreateAreaMode)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                    _createVNode(_component_v_icon, null, {
                                        default: _withCtx(() => _cache[0] || (_cache[0] = [
                                            _createTextVNode(" mdi-restore ")
                                        ])),
                                        _: 1 /* STABLE */,
                                        __: [0]
                                    }),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.localeInfo.cancelCreateButtonText), 1 /* TEXT */)
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    _createVNode(_component_v_icon, null, {
                                        default: _withCtx(() => _cache[1] || (_cache[1] = [
                                            _createTextVNode(" mdi-plus ")
                                        ])),
                                        _: 1 /* STABLE */,
                                        __: [1]
                                    }),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.localeInfo.createButtonText), 1 /* TEXT */)
                                ]))
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])), [
                        [
                            _directive_btn_style,
                            void 0,
                            "config",
                            {
                                primary: true,
                                outlined: true,
                                "size-m": true
                            }
                        ]
                    ])
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" 선택 영역 선택 기능 "),
                (_ctx.isSelectMode)
                    ? _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                        key: 1,
                        disabled: _ctx.selectedItem.length !== 1,
                        onClick: _ctx.handleClickSelectAreaBtn
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => _cache[2] || (_cache[2] = [
                                    _createTextVNode(" mdi-map-marker-radius ")
                                ])),
                                _: 1 /* STABLE */,
                                __: [2]
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.localeInfo.selectAreaText), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["disabled", "onClick"])), [
                        [
                            _directive_btn_style,
                            void 0,
                            "config",
                            {
                                primary: true,
                                outlined: true,
                                "size-m": true
                            }
                        ]
                    ])
                    : _createCommentVNode("v-if", true)
            ]),
            _createCommentVNode(" 구역 추가 영역 "),
            _withDirectives(_createVNode(_component_CreateRegisterAreaCard, { "handle-get-request-process": _ctx.handleGetRegisteredAreaListRequestProcess }, null, 8 /* PROPS */, ["handle-get-request-process"]), [
                [_vShow, _ctx.getterIsCreateAreaMode]
            ])
        ]),
        _createVNode(_component_v_divider),
        _createElementVNode("div", _hoisted_6, [
            _createCommentVNode(" 검색 "),
            _createVNode(_component_SearchInput, {
                width: "100%",
                "default-value": _ctx.getterAreaNameSearchValue,
                outlined: "",
                placeholder: _ctx.localeInfo.searchPlaceholder,
                "on-search": _ctx.handleSearchAreaName,
                "is-disabled": _ctx.getterIsCreateAreaMode,
                class: "area-search pb-4"
            }, null, 8 /* PROPS */, ["default-value", "placeholder", "on-search", "is-disabled"]),
            _createCommentVNode(" 구역명 리스트 "),
            _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_RegisteredAreaListTable, {
                    class: "area-list-table-wrapper",
                    "handle-get-request-process": _ctx.handleGetRegisteredAreaListRequestProcess,
                    "is-fetching": _ctx.isGetRegisteredAreaListFetching,
                    "is-error": _ctx.isGetRegisteredAreaListError
                }, null, 8 /* PROPS */, ["handle-get-request-process", "is-fetching", "is-error"])
            ]),
            _createVNode(_component_LoadingMask, {
                "is-fetching": _ctx.isGetRegisteredAreaListFetching,
                opacity: 0,
                color: "primary",
                size: "32"
            }, null, 8 /* PROPS */, ["is-fetching"])
        ])
    ], 2 /* CLASS */));
}
